import { render, staticRenderFns } from "./UISideBar.vue?vue&type=template&id=4370d53c"
import script from "./UISideBar.vue?vue&type=script&lang=ts"
export * from "./UISideBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports